import { render } from "./CloseIcon.vue?vue&type=template&id=4b9a757f"
const script = {}
script.render = render

export default script